import React, { useEffect, useState } from 'react';
import { Col, Row, Table, Spin, Badge } from "antd";
import { useSelector } from "react-redux";

import { getInvoicesList } from '../../redux/dashboard/dashboardActions';
import { formatCurrency, formatDate, parseDate } from '../../utils/utils';

const InvoicesTable = () => {
  const [spinStatus, setSpinStatus] = useState(false);

  const { invoicesList } = useSelector((state) => state.dashboard);

  useEffect(async () => {

    setSpinStatus(true);
    await getInvoicesList({ cardCode: localStorage.getItem('cardCode') });
    setSpinStatus(false);

  }, []);

  const columns = [
    {
      title: 'Invoice',
      dataIndex: 'invNum',
      key: 'invNum',
      width: 200,
      fixed: 'left',
      sorter: (a, b) => a.invNum - b.invNum,
      filterSearch: true,
      filters: [...new Set(invoicesList?.map(item => item.invNum))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.invNum === value,
    },
    {
      title: 'Ref No',
      dataIndex: 'refNo',
      key: 'refNo',
      width: 200,
      sorter: (a, b) => a.refNo - b.refNo,
      filterSearch: true,
      filters: [...new Set(invoicesList?.map(item => item.refNo))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.refNo === value,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 200,
      sorter: (a, b) => (a.status?.localeCompare(b.status)),
      render: (text) => {
        return (<Badge color={text === 'Closed' ? 'red' : text === 'Open' ? 'green' : text === 'Cancelled' ? 'orange' : 'yellow'} text={text} />);
      },
      filterSearch: true,
      filters: [...new Set(invoicesList?.map(item => item.status))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.status === value,
    },
    {
      title: 'Posting Date',
      dataIndex: 'postingDate',
      key: 'postingDate',
      width: 200,
      render: (text, record) => <div className={'hp-text-center'}>{formatDate(record.postingDate)}</div>,
      sorter: (a, b) => {
        const dateA = parseDate(a.postingDate);
        const dateB = parseDate(b.postingDate);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return dateA.valueOf() - dateB.valueOf();
      },
      filterSearch: true,
      filters: [...new Set(invoicesList?.map(item => item.postingDate))].map(val => ({ text: formatDate(val), value: val })),
      onFilter: (value, record) => record.postingDate === value,
    },
    {
      title: 'Delivery Date',
      dataIndex: 'delDate',
      key: 'delDate',
      width: 200,
      render: (text, record) => <div className={'hp-text-center'}>{formatDate(record.delDate)}</div>,
      sorter: (a, b) => {
        const dateA = parseDate(a.delDate);
        const dateB = parseDate(b.delDate);
        if (!dateA && !dateB) return 0;
        if (!dateA) return -1;
        if (!dateB) return 1;
        return dateA.valueOf() - dateB.valueOf();
      },
      filterSearch: true,
      filters: [...new Set(invoicesList?.map(item => item.delDate))].map(val => ({ text: formatDate(val), value: val })),
      onFilter: (value, record) => record.delDate === value,
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      width: 200,
      render: (text, record) => <div className={'hp-text-right'}>{formatCurrency(record.total)}</div>,
      sorter: (a, b) => a.total - b.total,
      filterSearch: true,
      filters: [...new Set(invoicesList?.map(item => item.total))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.total === value,
    },
    {
      title: 'Balance Due',
      dataIndex: 'balanceDue',
      key: 'balanceDue',
      width: 200,
      render: (text, record) => <div className={'hp-text-right'}>{formatCurrency(record.balanceDue)}</div>,
      sorter: (a, b) => a.balanceDue - b.balanceDue,
      filterSearch: true,
      filters: [...new Set(invoicesList?.map(item => item.balanceDue))].map(val => ({ text: val, value: val })),
      onFilter: (value, record) => record.balanceDue === value,
    },
  ];

  return (
    <Spin spinning={spinStatus} size="large">
      <Row gutter={[18, 18]}>
        <Col span={24}>
          <Table
            dataSource={invoicesList}
            size="small"
            bordered
            columns={columns}
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ['10', '15', '25', '50', '100'],
            }}
            scroll={{ x: '1000px' }}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default InvoicesTable;
